import swiperSliderInit from './swiper-slider';

export default swiperSliderInit;



// WEBPACK FOOTER //
// ./scripts/blocks/swiper-slider/index.js